import { atom } from "recoil";
import { IUpdateAssetDto } from "../services";

export const AssetUpdateState = atom<IUpdateAssetDto>({
  key: "assetUpdateState",
  default: undefined,
});
